import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Admin from './pages/Admin';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import rootReducer from './reducers';
import NavigationBar from './shared/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


const store = createStore(rootReducer);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <div>
      
    <Router>
      <NavigationBar />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customer/:id" element={<CustomerDetail />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
    </div>
  </Provider>
);
